export default __webpack_public_path__ + "static/media/ellipsTracht.a79363b1.png";